import React, { useMemo } from 'react';

const RULES = [
  { label: '12+ characters', test: p => p.length >= 12 },
  { label: 'Uppercase letter', test: p => /[A-Z]/.test(p) },
  { label: 'Lowercase letter', test: p => /[a-z]/.test(p) },
  { label: 'Number', test: p => /[0-9]/.test(p) },
  { label: 'Special character', test: p => /[^A-Za-z0-9]/.test(p) },
];

const STRENGTH_LABELS = ['', 'Weak', 'Weak', 'Fair', 'Good', 'Strong'];
const STRENGTH_COLORS = ['', 'var(--status-red, #ef4444)', 'var(--status-red, #ef4444)', '#f97316', '#eab308', 'var(--status-green, #22c55e)'];

export function getPasswordStrength(password) {
  if (!password) return { score: 0, label: '', passed: [] };
  const passed = RULES.filter(r => r.test(password));
  const score = passed.length;
  return { score, label: STRENGTH_LABELS[score] || '', passed };
}

export default function PasswordStrengthMeter({ password }) {
  const { score, label } = useMemo(() => getPasswordStrength(password || ''), [password]);
  const color = STRENGTH_COLORS[score] || '';

  if (!password) return null;

  return (
    <div style={{ marginTop: '6px' }}>
      {/* Strength bar */}
      <div style={{
        display: 'flex', gap: '3px', height: '4px', borderRadius: '2px', overflow: 'hidden',
      }}>
        {[1, 2, 3, 4, 5].map(i => (
          <div key={i} style={{
            flex: 1, borderRadius: '2px',
            background: i <= score ? color : 'var(--bg-tertiary, #e2e8f0)',
            transition: 'background 0.2s',
          }} />
        ))}
      </div>

      {/* Label + rules */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '4px' }}>
        <span style={{ fontSize: '0.72rem', fontWeight: 600, color }}>{label}</span>
        <span style={{ fontSize: '0.72rem', color: 'var(--text-muted, #94a3b8)' }}>{score}/5 requirements</span>
      </div>

      {/* Individual rules */}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px 10px', marginTop: '6px' }}>
        {RULES.map((rule, i) => {
          const passed = rule.test(password);
          return (
            <span key={i} style={{
              fontSize: '0.7rem', display: 'flex', alignItems: 'center', gap: '4px',
              color: passed ? 'var(--status-green, #22c55e)' : 'var(--text-muted, #94a3b8)',
            }}>
              {passed ? (
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12"/>
                </svg>
              ) : (
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"/>
                </svg>
              )}
              {rule.label}
            </span>
          );
        })}
      </div>
    </div>
  );
}
